// Axios
import axiosInstance from '../axios/axiosInstance';

const funcionarios = async () => {
  const res = await axiosInstance.get(`horas-extra/funcionarios/`);
  return res.data;
};

const justificativaPadrao = async () => {
  const res = await axiosInstance.get(`horas-extra/justificativa-padrao/`);
  return res.data;
};

const postHorasExtra = async (data) => {
  try {
    const res = await axiosInstance.post(`horas-extra/extra-hours/`, data,{responseType: 'blob'})
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const horasService = {
  funcionarios,
  justificativaPadrao,
  postHorasExtra
};

export default horasService;
